import { ChangeDetectorRef, Component, NgZone, ViewChild, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
@Component({
	selector: 'app-application',
	templateUrl: './application.component.html',
	styleUrls: [ './application.component.scss' ]
})
export class ApplicationComponent implements OnInit {
	apps: Array<any> = [
		// { name: 'Type Approval', description: 'Type Approval Application and Request for Permit' },
		// { name: 'Spectrum', description: 'License Application Renewal & Submission' },
		// { name: 'Numbering Management', description: 'License Application Renewal' }
		// { name: 'Economic Analysis and ', description: 'Operator Questionaires, Tarriff Managment' }
	];

	colors = [ '#DFF4EB', '#DCF0EB', '#F0EECC', '#F1E6DB', '#F8EBFC' ];
	organizationId: string;
	user: any;
	token: string;
	baseUrl = environment.API_SERVER;
	constructor(private location: Location, private cd: ChangeDetectorRef, private ngZone: NgZone) {
		this.user = JSON.parse(window.localStorage.getItem('user'));
		if (this.user) {
			// this.organizationId = JSON.parse(window.localStorage.getItem('userData'))['appUser'].appUserId;
			this.organizationId = this.user.appUserId;
			this.token = window.localStorage.getItem('jwt');
			let apps: Array<any> = [];
			this.apps = [];
			this.user['applications'].forEach((app) => {
				app['applicationHost'] = app['applicationHost'] + '?token=' + this.token;
				apps.push(app);
			});
			this.apps = apps;
			this.apps.map((app) => {
				app.color = this.generateColors();
			});
			// this.cd.markForCheck();
		}
	}

	generateColors() {
		let color = this.colors[Math.floor(Math.random() * this.colors.length)];
		return color;
	}
	ngOnInit() {}
	goBack() {
		this.location.back();
	}
	onSlideChange() {}
}
